// extracted by mini-css-extract-plugin
module.exports = {"RoundPlusButton":"style_RoundPlusButton__2g4aX","circle":"style_circle__2L9us","text":"style_text__27ayk"};